import{createContext as a}from"react";var r=a({charts:new Map,onChartChange:function(){}});export{r as default};
